<div class="async-block-wrapper" [class.in-request]="inRequest()">
  <div class="app-loading-wrapper">
    <app-loading></app-loading>
  </div>

  <section class="content">
    <ng-content></ng-content>
  </section>
</div>
